import { render } from "./FillInTheBlank.vue?vue&type=template&id=fe0fd99e&scoped=true"
import script from "./FillInTheBlank.vue?vue&type=script&lang=js"
export * from "./FillInTheBlank.vue?vue&type=script&lang=js"

import "./FillInTheBlank.vue?vue&type=style&index=0&id=fe0fd99e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0fd99e"]])

export default __exports__